import themeInfo from '../../../styles/themes'
import './site-header.css'

declare const initialStateFromServer 

const StaticHeader = () => {

	const theme = initialStateFromServer.theme
	const brandLogo1 = themeInfo.find(t => t.theme == theme).images.brandLogo1

	return (
		<header className="site-header" style={{backgroundColor:'transparent'}}>
			<div className='top-bar'>
				<div className='left panel'>
					<a href="/"><img className="logo" src={brandLogo1}></img></a>
				</div>
			</div>
		</header>
	)
}

export default StaticHeader